import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _forEach from "lodash/forEach";
import _reduce from "lodash/reduce";

var _ProviderContactInfo, _ProviderAliases;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TransunionProviders = {
  AMERICAN_EXPRESS: 'American Express',
  BANK_OF_AMERICA: 'Bank of America',
  BARCLAYS: 'Barclays',
  CAPITAL_ONE: 'Capital One',
  CHASE: 'Chase',
  CITI: 'Citi',
  DISCOVER: 'Discover',
  SYNCHRONY_FINANCIAL: 'Synchrony Financial',
  US_BANCORP: 'U.S. Bancorp',
  WELLS_FARGO: 'Wells Fargo',
  CORNERSTONE: 'CornerStone',
  FED_LOAN_SERVICING: 'Fed Loan Servicing',
  GRANITE_STATE: 'Granite State',
  GREAT_LAKES: 'Great Lakes',
  HESC_EDFINANCIAL: 'HESC/Edfinancial',
  MOHELA: 'MOHELA',
  NAVIENT: 'Navient',
  NELNET: 'Nelnet',
  OSLA_SERVICING: 'OSLA Servicing'
};
var ProviderContactInfo = (_ProviderContactInfo = {}, _defineProperty(_ProviderContactInfo, TransunionProviders.AMERICAN_EXPRESS, {
  phone: '800-528-2122'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.BANK_OF_AMERICA, {
  phone: '800-732-9194'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.BARCLAYS, {
  phone: '866-928-8598'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.CAPITAL_ONE, {
  phone: '800-227-4825'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.CHASE, {
  phone: '800-432-3117'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.CITI, {
  phone: '800-950-5114'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.DISCOVER, {
  phone: '800-347-2683'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.SYNCHRONY_FINANCIAL, {
  phone: '866-419-4096'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.US_BANCORP, {
  phone: '800-872-2657'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.WELLS_FARGO, {
  phone: '800-642-4720'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.CORNERSTONE, {
  phone: '800-663-1662'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.FED_LOAN_SERVICING, {
  phone: '800-699-2908'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.GRANITE_STATE, {
  phone: '888-556-0022'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.GREAT_LAKES, {
  phone: '800-236-4300'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.HESC_EDFINANCIAL, {
  phone: '855-337-6884'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.MOHELA, {
  phone: '888-866-4352'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.NAVIENT, {
  phone: '800-722-1300'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.NELNET, {
  phone: '888-486-4722'
}), _defineProperty(_ProviderContactInfo, TransunionProviders.OSLA_SERVICING, {
  phone: '866-264-9762'
}), _ProviderContactInfo);
var ProviderAliases = (_ProviderAliases = {}, _defineProperty(_ProviderAliases, TransunionProviders.AMERICAN_EXPRESS, ['amex', 'american express']), _defineProperty(_ProviderAliases, TransunionProviders.BANK_OF_AMERICA, ['bofa', 'bank of america', 'bk of amer']), _defineProperty(_ProviderAliases, TransunionProviders.BARCLAYS, ['barclays']), _defineProperty(_ProviderAliases, TransunionProviders.CAPITAL_ONE, ['capitalone', 'capital one', 'cap one']), _defineProperty(_ProviderAliases, TransunionProviders.CHASE, ['chase', 'chase card']), _defineProperty(_ProviderAliases, TransunionProviders.CITI, ['citi']), _defineProperty(_ProviderAliases, TransunionProviders.DISCOVER, ['discover', 'discoverbank']), _defineProperty(_ProviderAliases, TransunionProviders.SYNCHRONY_FINANCIAL, ['synchrony']), _defineProperty(_ProviderAliases, TransunionProviders.US_BANCORP, ['u.s. bancorp', 'us bancorp']), _defineProperty(_ProviderAliases, TransunionProviders.WELLS_FARGO, ['wells fargo']), _defineProperty(_ProviderAliases, TransunionProviders.FED_LOAN_SERVICING, ['fed loan servicing']), _defineProperty(_ProviderAliases, TransunionProviders.GRANITE_STATE, ['granite state']), _defineProperty(_ProviderAliases, TransunionProviders.GREAT_LAKES, ['great lakes']), _defineProperty(_ProviderAliases, TransunionProviders.NAVIENT, ['navient']), _defineProperty(_ProviderAliases, TransunionProviders.NELNET, ['nelnet']), _defineProperty(_ProviderAliases, TransunionProviders.CORNERSTONE, ['cornerstone']), _defineProperty(_ProviderAliases, TransunionProviders.HESC_EDFINANCIAL, ['hesc/edfinancial', 'hesc', 'edfinancial']), _defineProperty(_ProviderAliases, TransunionProviders.MOHELA, ['mohela']), _defineProperty(_ProviderAliases, TransunionProviders.OSLA_SERVICING, ['osla servicing', 'osla']), _ProviderAliases);
export var ProviderToContactInfoMapping = _reduce(ProviderAliases, function (acc, aliases, provider) {
  _forEach(aliases, function (alias) {
    acc[alias] = _objectSpread({
      provider: provider
    }, ProviderContactInfo[provider]);
  });

  return acc;
}, {});